import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface EditGeneratedTitleModalData {
	description: string;
}

@Component({
	selector: 'app-edit-generated-title',
	templateUrl: './edit-generated-title.component.html',
	styleUrls: ['./edit-generated-title.component.scss'],
	standalone: false,
})
export class EditGeneratedTitleComponent {
	description: string;
	originalTitle: string;
	submitted = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: EditGeneratedTitleModalData,
		public dialogRef: MatDialogRef<EditGeneratedTitleComponent>,
	) {
		this.description = data.description;
		this.originalTitle = data.description;
	}

	save(form: NgForm) {
		this.submitted = true;
		if (form.valid) {
			this.dialogRef.close(this.description);
		}
	}

	close() {
		this.dialogRef.close();
	}
}
